export const REACT_APP_NAME =
  process.env.REACT_APP_NAME || 'customer-portal-touchlatam';
export const MAIN_BACKEND_URL =
  process.env.REACT_APP_MAIN_BACKEND_URL || 'someapi.com';
export const APP_LANGUAGE = process.env.REACT_APP_LANGUAGE || 'en';
export const ENV = process.env.NODE_ENV || 'development';
export const DEFAULT_DASHBOARD_ROUTE= '/file-editor';
export const DEFAULT_GUEST_ROUTE= '/login';
